import cn from "classnames";
import { Button } from "shared/ui/Button";
import { UpdateIcon } from "shared/ui/Icons";
import styles from "./UpdateAllButton.module.scss";

type UpdateAllButtonProps = {
  onClick: () => void;
};

export const UpdateAllButton: RFC<UpdateAllButtonProps> = ({ onClick }) => {
  return (
    <Button data-test-id="update-all-button" onClick={onClick} className={cn(styles.button)}>
      <UpdateIcon />
    </Button>
  );
};
